export default function InputMobile() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            model: "=",
            validation: "=",
        },
        template: require("./template.html"),
        controller: function ($scope, $timeout) {
            $timeout(() => {
                $scope.model.mobile = $scope.model.mobile
                    ? Number($scope.model.mobile)
                    : null;
                $scope.display = true;
            }, 500);
        },
    };
}
